import { decryptData, formatedDate } from "./helpers";

export default function printDiv(divName, details) {
  const user = decryptData(
    localStorage.getItem("userInfo"),
    process.env.VUE_APP_SECRET_KEY
  );
  const originalContents = document.body.innerHTML;
  setTimeout(() => {
    const printEl = document.getElementById(divName);
    const printContents = printEl ? printEl.innerHTML : "";
    const html = `<div style="width: 100% !important;">
  <h2 style="font-size: 1rem; font-weight: 600; text-align: center;">${details?.title ||
    ""}</h2>
  <div style="display: ${
    details?.imageUrl ? "flex" : "none"
  }; justify-content: space-between; margin-top : 0.2rem;">
  <img style="max-width: 12rem; max-height :3rem ;" src="${
    details?.imageUrl
  }"/> <img style="max-width: 12rem; max-height :3rem" src="${
      user.isOther === 0 ? details?.imageUrl2 : ""
    }"/>
  </div>
  <div style="display: flex; justify-content: space-between;">
  <p>${
    details?.startDate ? "From " + details?.endDate + " to " : ""
  }${details?.endDate || ""}</p><p>${
      details?.printedBy ? "Printed by " + details?.printedBy : ""
    }</p></div>
  ${printContents}
  </div>`;
    document.body.innerHTML = html;
    document.title = `${details?.mrNo ? details.mrNo + "/" : ""} ${
      details?.invoiceNo ? details.invoiceNo + "/" : ""
    } ${formatedDate()}`;
    window.print();
    location.reload();
    document.body.innerHTML = originalContents;
  }, 1000);
  window.onload = function() {};
}
